import { render, staticRenderFns } from "./StaffHoldReservation.vue?vue&type=template&id=07944e6a&scoped=true&"
import script from "./StaffHoldReservation.vue?vue&type=script&lang=js&"
export * from "./StaffHoldReservation.vue?vue&type=script&lang=js&"
import style0 from "./StaffHoldReservation.vue?vue&type=style&index=0&id=07944e6a&prod&lang=scss&scoped=true&"
import style1 from "./StaffHoldReservation.vue?vue&type=style&index=1&id=07944e6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07944e6a",
  null
  
)

export default component.exports